import {useEffect, useState} from "react";
import ContainerComponent from "../../../components/elements/ContainerComponent";
import {TableWithStripedRows} from "../../../components/elements/Tables/TableComponent";
import {Button} from "@material-tailwind/react";


function ProductListComponent(props) {
  const [didMount, setDidMount] = useState(false);
  const {list} = props;

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (didMount) {
      list();
    }
  }, [didMount, list]);

  const columnsName = [
    {
      selector: row => row.id,
      name: 'No.',
    },
    {
      selector: row => row.name,
      name: 'Nombre',
    },
    {
      selector: row => row.category?.description,
      name: 'Categoria',
    },
  ]

  const Filters = [
    {
      placeholder: 'Categorias',
      name_filter: 'category__id',
      urlOptionList: '/category/select_option'
    }
  ]

  return (
    <>
      <ContainerComponent
        uri={'crear'}
        title="Productos"
        textBtnCreate={'Crear Producto'}
      >
        <TableWithStripedRows
          titleExcel="Productos"
          loader={props.loader}
          data={props.data}
          page={props.page}
          columns={columnsName}
          list={list}
          filters={Filters}
          changeFilter={props.changeFilterById}
          ChangeRowsPerPage={props.ChangeRowsPerPage}
          actionDelete={props.deleteRecord}
          searchChange={props.searchChange}
          searchValue={props.search}
        />
      </ContainerComponent>
    </>
  )

}

export default ProductListComponent